import { render, staticRenderFns } from "./ShopBackEditComponent.vue?vue&type=template&id=3928acf3&scoped=true"
import script from "./ShopBackEditComponent.vue?vue&type=script&lang=js"
export * from "./ShopBackEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopBackEditComponent.vue?vue&type=style&index=0&id=3928acf3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3928acf3",
  null
  
)

export default component.exports